import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline"
import InfoIcon from "@mui/icons-material/Info"
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material"
import { styled } from "@mui/material/styles"
import { format, parseISO } from "date-fns"
import { toZonedTime } from "date-fns-tz"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"

import { useSelector } from "react-redux"
import { FileState } from "../../../store/actions/file"
import { RootState } from "../../../store/reducers"
import Status from "../../status"

const TableCellStyled = styled(TableCell)(() => ({
	paddingLeft: "8px",
}))

const FileRow = ({
	handleDownload,
	row,
}: {
	handleDownload: (fileId: string, filename: string) => void
	row: FileState
}) => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

	const userPermissions = useSelector(
		(state: RootState) => state.auth?.user?.permissions
	)

	const hasViewTransactionEnabled: boolean = userPermissions
		? userPermissions.some(
				(perm) =>
					perm.permissionName === "VIEW_TRANSACTION" && perm.enabled === true
			)
		: false

	const creationDate: Date | undefined = row?.creationDate
		? parseISO(row.creationDate)
		: undefined
	const zonedDate = creationDate
		? toZonedTime(creationDate, userTimeZone)
		: undefined
	const formattedDateTime =
		zonedDate && format(zonedDate, "dd/MM/yyyy HH:mm:ss")

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={row.id}
			style={{
				backgroundColor: row.correctFile ? "inherit" : "rgba(211, 47, 47, 0.1)",
			}}
		>
			<TableCellStyled component="td" scope="row" padding="none">
				{row.originalFileName}
			</TableCellStyled>
			<TableCellStyled align="right">{row.plicksCount}</TableCellStyled>
			<TableCellStyled align="left">{row.idBank}</TableCellStyled>{" "}
			<TableCellStyled align="left">{row.corporateSenderId}</TableCellStyled>
			<TableCellStyled align="left">{row.campaignName}</TableCellStyled>{" "}
			<TableCellStyled align="left">
				<Status status={row.status} />
			</TableCellStyled>{" "}
			<TableCellStyled align="right">{row.totalAmount}</TableCellStyled>
			<TableCellStyled align="left">{formattedDateTime}</TableCellStyled>
			<TableCellStyled align="center">
				{hasViewTransactionEnabled && (
					<IconButton
						color="primary"
						onClick={() =>
							navigate(
								`/distinta/${row?.id}?filename=${encodeURIComponent(row.originalFileName)}`,
								{ state: { filename: row.originalFileName } }
							)
						}
					>
						<Tooltip title={t("tooltips.viewDetail", { ns: "distinte" })}>
							<InfoIcon />
						</Tooltip>
					</IconButton>
				)}
				<IconButton
					color="primary"
					onClick={() =>
						handleDownload(row.id.toString(), row.originalFileName)
					}
				>
					<Tooltip title={t("tooltips.downloadError", { ns: "distinte" })}>
						<DownloadForOfflineIcon />
					</Tooltip>
				</IconButton>
			</TableCellStyled>
		</TableRow>
	)
}

export default FileRow
